export const HOT_YOTER_STATE_TYPE = {
    NOT_YET: 'not_yet',
    GOT_ONE: 'got_one',
    GOT_TWO: 'got_two',
    GOT_GOLD: 'got_gold',
    LEFT_ONE: 'left_one',
    LEFT_ZERO: 'left_zero',
    HAS_NOT_AGREED_SUBSIDY_PLAN: 'has_apprvoed_subsidy_plan',
};
